<template>
  <div class="service-item">
    <div v-if="isNew" class="service-badge-container new-badge"></div>
    <div v-if="imageSource" class="service-image-container">
      <v-img :src="imageSource" class="service-image" height="396" cover></v-img>
    </div>
    <div class="service-title text-center text-h5 pa-4">{{title}}</div>
    <div v-if="subTitle" class="service-subtitle text-center pa-4">{{subTitle}}</div>
    <div class="service-booking-options" v-if="bookingOptions && bookingOptions.length">
      <div class="service-booking-item d-flex justify-space-between align-center px-4 py-2" 
           v-for="option in bookingOptions" :key="option.label">
        <div class="service-booking-label">{{option.label}}</div>
        <v-btn color="primary" :href="option.bookingUrl" :target="linkTarget" class="book-now-button-sm" 
               variant="flat" size="small" prepend-icon="$mdi-calendar-plus">Book now!</v-btn>
      </div>
    </div>
    <div class="service-actions d-flex flex-column align-center ga-2 px-8" v-if="!bookingOptions || !bookingOptions.length">
      <v-btn color="primary" :href="bookNowLink" :target="linkTarget" class="book-now-button" 
              prepend-icon="$mdi-calendar-plus">{{ buttonText }}</v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import BookingOption from '@/models/BookingOption';

// Components

export default defineComponent({
  name: 'ServiceItemComponent',

  props: {
    imageSource: {
      type: String
    },
    title: {
      type: String
    },
    subTitle: {
      type: String,
      required: false
    },
    bookNowLink: {
      type: String,
      required: false
    },
    linkTarget: {
      type: String,
      default: '_blank'
    },
    buttonText: {
      type: String,
      default: 'Book now!'
    },
    readMoreLink: {
      type: String,
      required: false
    },
    bookingOptions: {
      type: Array as PropType<BookingOption[]>,
      default: (): BookingOption[] => []
    },
    isNew: {
      type: Boolean,
      default: false
    }
  },

  components: {
    
  },
});
</script>

<style scoped>
.service-item {
  max-width: 400px;
  min-width: 275px;
  width: 100%;
  border: 2px solid rgb(var(--v-theme-primary));
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  font-size: 18px;
  background-color: rgba(var(--v-theme-primary), 0.08);
  transition: box-shadow 0.3s ease;
  display: grid;
  grid-template-rows:
    auto
    var(--service-title-height, auto)
    var(--service-subtitle-height, auto)
    var(--service-price-height, auto)
    var(--service-actions-height, auto);
}

.service-badge-container {
  position: absolute !important;
  overflow: visible !important;
  top: 0;
  left: -7px;
  width: 100%;
  height: 0;
}

.service-item:hover {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.service-image-container {
  position: relative;
  overflow: hidden;
  grid-row: 1;
}

.service-image {
  transition: transform 0.5s ease;
}

.service-item:hover .service-image {
  transform: scale(1.05);
}

.quick-book-button {
  background-color: rgba(var(--v-theme-primary), 0.9) !important;
}

.service-title {
  font-weight: 600;
  margin-top: 10px;
  min-height: var(--service-title-height, auto);
  grid-row: 2;
}

.service-subtitle {
  min-height: var(--service-subtitle-height, auto);
  font-style: italic;
  opacity: 0.9;
  grid-row: 3;
}

.service-booking-options {
  min-height: var(--service-booking-options-height, auto);
  background-color: rgba(var(--v-theme-primary), 0.06);
  border-radius: 15px;
  padding: 10px 15px 30px;
  grid-row: 4;
}

.service-booking-item {
  padding: 15px !important;
  border-bottom: 1px solid rgba(var(--v-theme-primary), 0.2);
  transition: background-color 0.2s ease;
}

.service-booking-item:last-child {
  border-bottom: none;
}

.service-booking-item:hover {
  background-color: rgba(var(--v-theme-primary), 0.1);
}

.service-booking-label {
  font-weight: 500;
}

.book-now-button-sm {
  font-weight: 600;
  border-radius: 10px;
  transition: transform 0.2s ease;
}

.book-now-button-sm:hover {
  transform: scale(1.03);
}

.book-now-button {
  font-weight: 600;
  border-radius: 15px;
  width: 80%;
  margin-bottom: 10px;
  transition: transform 0.2s ease;
}

.service-actions {
  grid-row: 5;
  min-height: var(--service-actions-height, auto);
  padding: 10px 15px 20px;
}

.book-now-button:hover {
  transform: scale(1.03);
}

@media (max-width: 600px) {
  .service-item {
    width: 100%;
  }
}
</style>
